export const contentTypeMultipartFormData = {
  'Content-Type': 'multipart/form-data',
};
